import { useQueryClient } from 'react-query'

import { LinkCardRequest, LinkCardResponse } from '@cash-web/protos/squareup/franklin/app/card.pb'
import { GetProfileResponse } from '@cash-web/protos/squareup/franklin/app/profile.pb'
import { useQueryGetProfile } from '@cash-web/shared-data-access-api/react-query/useQueryGetProfile'
import { createReactQueryMutationHook } from '@cash-web/shared-data-access-api/types'
import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'

import { basePath } from '.'
import { updateInstruments } from './instrumentsUtil'

export function decodeInstrumentTokenToReplace(initiationDataString: string): string | undefined {
  try {
    const url = new URL(`dummy://dummy/${initiationDataString}`)
    const paramsEncoded = url.searchParams.get('params')
    const paramsType = url.searchParams.get('params_type')

    if (!paramsEncoded || paramsType !== 'json') {
      return undefined
    }

    const jsonString = atob(paramsEncoded)
    const params = JSON.parse(jsonString) as Record<string, unknown>
    return params?.['instrumentTokenToReplace'] as string | undefined
  } catch {
    return undefined
  }
}

export const LinkCard = (data: LinkCardRequest, config?: CashRequestOptions): Promise<LinkCardResponse> =>
  post<LinkCardRequest, LinkCardResponse>(`${basePath}/link-card`, data, config)

const useMutationLinkCard = createReactQueryMutationHook<
  LinkCardRequest & { instrumentTokenToReplace?: string },
  LinkCardResponse
>('linkCard', ({ instrumentTokenToReplace, ...data }, config) => LinkCard(data, config))

export const useOptimisticMutationLinkCard = (params?: Parameters<typeof useMutationLinkCard>[0]) => {
  const queryClient = useQueryClient()

  return useMutationLinkCard({
    ...params,
    mutationOptions: {
      onSuccess: (response, variables) => {
        const instrument = response.instrument
        const token = instrument?.token

        if (token === undefined || instrument === undefined) {
          return
        }

        const tokenToReplace = variables.instrumentTokenToReplace

        queryClient.setQueryData<GetProfileResponse | undefined>(useQueryGetProfile.rootQueryKey, response => {
          if (response === undefined) {
            return undefined
          }

          const currentInstruments = response.profile?.instruments ?? []

          const res = {
            ...response,
            profile: {
              ...response.profile,
              instruments: updateInstruments({
                instruments: currentInstruments,
                newInstrument: { ...instrument, token },
                tokenToReplace,
              }),
            },
          }

          return res
        })
      },
    },
  })
}
